import { CheckIcon } from "@heroicons/react/24/solid";
import { TWclassNames } from "./Div";

/**
 * Phase stepper — Promang component kit (PROMANG_COMPONENTS.md §6 Stepper,
 * `pm-steps*` classes in src/index.css).
 *
 * `steps`: [{ id, title, active }]; steps with `active !== true` are hidden.
 * `selected`: the current step. Steps with a lower id are shown as done.
 */
export default function PMSteps({ steps = [], selected, onChange }) {
  const visibleSteps = steps.filter((step) => step.active === true);
  const selectedId = selected?.id;

  return (
    <nav aria-label="Progress">
      <ol role="list" className="pm-steps">
        {visibleSteps.map((step, index) => {
          const isCurrent = step.id === selectedId;
          const isDone = selectedId != null && step.id < selectedId;
          return (
            <li key={step.id ?? step.title} className="min-w-0">
              <button
                type="button"
                onClick={() => onChange?.(step)}
                className={TWclassNames(
                  "pm-steps__item w-full",
                  isDone ? "is-done" : "",
                  isCurrent ? "is-current" : ""
                )}
                aria-current={isCurrent ? "step" : undefined}
              >
                <span className="pm-steps__track">
                  <span className="pm-steps__dot">
                    {isDone ? <CheckIcon className="h-4 w-4" aria-hidden="true" /> : index + 1}
                  </span>
                  <span className="pm-steps__line" aria-hidden="true" />
                </span>
                <span className="pm-steps__label truncate max-w-full">{step.title}</span>
              </button>
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
